module.exports = __webpack_public_path__ + "media/images/home/ebs-09f1fab8543c01c86ddfde9da4505765.png";